import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { saveProductRemarks } from '@services/collectionService';

const ProductRemarks = ({ product }) => {
	const [remarks, setRemarks] = useState('');
	const dispatch = useDispatch();

	useEffect(() => {
		if (product?.collectionRemarks) {
			setRemarks(product?.collectionRemarks);
		}
	}, [product?.collectionRemarks]);

	const saveRemarks = async (e, productId) => {
		if (product?.collectionRemarks !== remarks) {
			try {
				dispatch(openLoader());
				await saveProductRemarks(productId, `?remarks=${e.target.value}`);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	return (
		<textarea
			className="table-column-textarea"
			value={remarks}
			onChange={(e) => setRemarks(e.target.value)}
			onBlur={(e) => saveRemarks(e, product.id)}
		/>
	);
};

export default ProductRemarks;
